<template>
    <div class="vertical-container">
        <div class="vertical-container__header vertical-container__header--has-shadow" v-if="projects.length">
            <div class="container">
                <h1>Založené projekty</h1>
            </div>
        </div>
        <div class="vertical-container__content">
            <div class="elementary-section elementary-section--full">
                <div class="elementary-section__in">
                    <div class="container">
                        <div class="w--xxl" v-if="projects.length">
                            <ul class="list list--even-odd-background">
                                <li v-for="project in projects">
                                    <router-link :to="{name: 'project-detail', params: {projectId: project.id}}">
                                        {{ project.title }}
                                    </router-link>
                                </li>
                            </ul>
                            <custom-button outline @click="createProject">Založit nový projekt</custom-button>
                        </div>
                        <div class="onboarding" v-else>
                            <h1 class="onboarding__heading">Vítáme Vás v domovio!</h1>

                            <p class="onboarding__hero">V administračním systému<br>pro správu developerských projetků.</p>

                            <p class="onboarding__text">
                                Krok <strong>1</strong> ze <strong>2</strong>
                            </p>

                            <h2 class="onboarding__step">Zadejte název projektu</h2>

                            <div class="onboarding__form onboarding__form--project">
                                <project-title-form ref="form" :processing="processing" @o3-submit="onSubmit($event)"/>
                            </div>

                            <p class="onboarding__text">
                                V následujícím kroku budete moci zakládat jednotky.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ProjectTitleForm from '@/modules/ProjectModule/components/Project/Form/ProjectTitleForm';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import CreateProjectDialog from '@/modules/ProjectModule/components/Project/CreateProjectDialog';

export default {
    components: {CustomButton, ProjectTitleForm},
    data() {
        return {
            processing: false,
        }
    },
    computed:   {
        projects() {
            return this.$store.getters['projects/projects'];
        }
    },
    methods:    {
        createProject() {
            this.$modal.show(CreateProjectDialog);
        },
        onSubmit(data) {
            this.processing = true;
            this.$store.dispatch('projects/createProject', data)
                .then(({id}) => {
                    this.$router.push({name: 'project-unit-default', params: {projectId: id}, query: {start: true}})
                })
                .catch((message) => this.$dmv.notifyError(message))
                .finally(() => this.processing = false);
        }
    }
}
</script>
